import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Psychology as TriviaIcon, ArrowForward as ArrowIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import HomeSection from "./HomeSection";
import { homeCardHover } from "./homeStyles";
import { brandOutlinedButtonSx } from "../../utils/brandAssets";
import { getSportPath } from "../../utils/sportWorkspace";

const TRIVIA_SUBTITLES = {
  mlb: "Know your baseball history?",
  nba: "Know your basketball history?",
  nfl: "Know your football history?",
};

const TriviaChallenge = ({ sport = "mlb" }) => {
  const navigate = useNavigate();
  const triviaPath = getSportPath(sport, "trivia");

  return (
    <HomeSection
      title="Trivia challenge"
      subtitle={TRIVIA_SUBTITLES[sport] || TRIVIA_SUBTITLES.mlb}
    >
      <Box
        onClick={() => navigate(triviaPath)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          ...homeCardHover,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(236, 72, 153, 0.15)",
            }}
          >
            <TriviaIcon sx={{ color: "#ec4899", fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="body1" fontWeight={600}>
              Test what you know
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Player comparisons, career milestones, and legendary moments — prove
              you&apos;ve done the homework.
            </Typography>
          </Box>
        </Box>
        <Button
          variant="outlined"
          endIcon={<ArrowIcon />}
          onClick={(e) => {
            e.stopPropagation();
            navigate(triviaPath);
          }}
          sx={{
            flexShrink: 0,
            display: { xs: "none", sm: "inline-flex" },
            ...brandOutlinedButtonSx,
          }}
        >
          Play trivia
        </Button>
      </Box>
    </HomeSection>
  );
};

export default TriviaChallenge;
